import { TargetType } from './enum'

/**
 * 一级菜单显示
 * @author liuzhiqiang
 */
export default class MenuItem {
    /**
     * 菜单ID
     */
    public menuId:string;
    /**
     * 菜单显示名称
     */
    public name:string;
    /**
     * 点击后的页面动作,当前窗口(page)或新窗口(blank)
     */
    // public static final String TARGET_PAGE  = "page";
    // public static final String TARGET_BLANK = "blank";
    public target:TargetType;
    /**
     * 菜单URL ,带域名（无协议符）
     */
    public url:string;
    /**
     * 系统的应用名称（例如选课，排课等)
     */
    public appName:string;
    /**
     * 二级菜单
     */
    public subMenus:MenuItem[];
    constructor({ menuId = '', name = '', target = TargetType.TARGET_PAGE, url = '', appName = '',subMenus=[] }={}) {
        this.menuId = menuId;
        this.name = name;
        this.target = target;
        this.url = url;
        this.appName = appName;
        this.subMenus = subMenus||[];
    }
}